__webpack_require__.p = "/Medimart/";